import axios from 'axios';
import { currentlySelectedLanguage } from '../helper';
 const customerPartnerClient = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL_CUSTOMER_PARTNER,
    withCredentials: true
});


  //Request Interceptor
  customerPartnerClient.interceptors.request.use(function (config) {
    config.headers['Accept-Language'] =  currentlySelectedLanguage();
      // Do something before request is sent
      return config;
  
  }, function (error) {
  
      // Do something with request error
      return Promise.reject(error);
  
  });


export default customerPartnerClient;